import { ActionsEnum } from "../enum/actions-enum";
import LaudoSimplificado from "../../models/laudo-simplificado";
import Laudo from "../../models/laudo";
import { FiltroLaudo } from "../../models/filtros/filtro-laudo";

const initialState = {
	laudoSession: new LaudoSimplificado(),
	newListLaudo: new Array<LaudoSimplificado>(),
	newLaudoCompleto: new Laudo(),
	newLaudoCompletoAlterado: new Laudo(),
	codigoLaudo: 0,
	edicao: false,
	fromListaLaudos: false,
	filtroLaudoSession: new FiltroLaudo(),
	identificacaoObraPreenchida: false,
	metodosProcedimentosPreenchidos: false,
	tipoDeLaudo: '',
	atividadeExploradaControl: false
	
};
export const laudoReducer = (state = initialState, action): any => {
	switch (action.type) {
		case ActionsEnum.UPDATE_LAUDO:
			return {
				...state,
				laudoSession: action.laudoSession,
			};
		case ActionsEnum.UPDATE_LIST_LAUDO:
			return {
				...state,
				newListLaudo: action.newListLaudo,
			};
		case ActionsEnum.UPDATE_LAUDO_COMPLETO:
			return {
				...state,
				newLaudoCompleto: action.newLaudoCompleto,
			};
		case ActionsEnum.UPDATE_LAUDO_COMPLETO_EDICAO:
			return {
				...state,
				newLaudoCompletoAlterado: action.newLaudoCompletoAlterado,
			};
		case ActionsEnum.UPDATE_LAUDO_PARAMS:
			return {
				...state,
				codigoLaudo: action.codigoLaudo,
				edicao: action.edicao,
				fromListaLaudos: action.fromListaLaudos,
				tipoDeLaudo: action.tipoDeLaudo,
			};
		case ActionsEnum.UPDATE_FILTRO_LAUDO:
			return {
				...state,
				filtroLaudoSession: action.filtroLaudoSession,
			};
		case ActionsEnum.UPDATE_IDENTIFICACAO_OBRA_PREENCHIDA:
			return {
				...state,
				identificacaoObraPreenchida: action.identificacaoObraPreenchida
			}
		case ActionsEnum.UPDATE_METODOS_PROCEDIMENTOS_PREENCHIDOS:
			return {
				...state,
				metodosProcedimentosPreenchidos: action.metodosProcedimentosPreenchidos
			}
		case ActionsEnum.UPDATE_ATIVIDADES_EXPLORADAS:
			return {
				...state,
				atividadeExploradaControl: !state.atividadeExploradaControl
			}
		default:
			return state;
	}
};
